export function isWalletProviderDescriptor(p) {
    return typeof p.loadProvider === 'function';
}
